export default __webpack_public_path__ + "static/media/followers.10f70a8d.svg";